module.exports = __webpack_public_path__ + "static/media/home-students@3x.78cead42.png";